<template>
  <section>
    <Banner value="Localização"/>
    <hr style="border:5px solid #DDD">
    <section style="background:#DDD;">
      <v-container grid-list-xl>
        <v-layout row wrap my-2>
          <v-flex xs12>
            <p
              class="lead"
            >Para chegar na Escola Engenho é muito fácil. Você pode clicar no botão do Google Maps abaixo para navegar pelo seu celular e ver vídeos que mostram como vir para a escola a partir de vários locais em Florianópolis.</p>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <section class="section">
      <v-container grid-list-xl>
        <v-layout align-start justify-space-around row fill-height wrap my-4>
          <v-flex sm12 md5 lg4 xl3 mb-4>
            <h1 style="text-align:center; font-size:25px; line-height:1.1em;">
              <span style="font-size:45px;">Navegue</span>
              <br>pelo mapa
            </h1>
            <br>
            <h4>Vá usando o Google Maps</h4>
            <v-btn :href="$store.state.maps" target="_blank" block round large color="success">
              <i class="fa-2x fas fa-map-marker-alt"></i> Google maps
            </v-btn>
            <br>
            <h4>Vá usando o Waze</h4>
            <v-btn
              block
              round
              large
              outline
              dark
              color="deep-purple darken-3"
              :href="$store.state.waze"
              target="_blank"
            >
              <i class="fa-2x fab fa-waze"></i> Ir pelo Waze
            </v-btn>
          </v-flex>
          <v-flex sm12 md5 lg4 xl3>
            <h1 style="text-align:center; font-size:25px; line-height:1.1em;">
              <span style="font-size:45px;">Endereço</span>
              <br>completo
            </h1>
            <br>
            <p class="lead">
              Rua Valdomiro José Vieira, 94
              <br>Campeche - Florianópolis - SC
              <br>CEP 88063-035
            </p>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <!-- <section class="section" style="background:#EEEEEE">
      <v-container fluid grid-list-xl>
        <v-layout align-start justify-space-around row fill-height wrap>
          <v-flex sm12 style="text-align:center;" my-4>
            <h1 style="text-align:center; font-size:25px; line-height:1.1em;">
              <span style="font-size:45px;">Veja vídeos</span>
              <br>de como chegar
            </h1>
          </v-flex>
          <v-flex xs12 sm12 md4 style="text-align:center;" my-4 v-for="(o, i) in sentidos" :key="i">
            <p class="lead">{{o.title}}</p>
            <YouTube :code="o.youtube"/>
          </v-flex>
        </v-layout>
      </v-container>
    </section>-->
  </section>
</template>

<script>
import Banner from "../../components/Banner";
import YouTube from "../../components/YouTube";

export default {
  data: () => ({
    sentidos: [
      { title: "Vindo do centro de Florianópolis", youtube: "RtKeYxcMwx8" },
      { title: "Vindo do Sul da Ilha", youtube: "f8h8Unp-XR4" },
      { title: "Vindo da Lagoa da Conceição", youtube: "r5xBat_FU98" }
    ]
  }),
  components: {
    Banner,
    YouTube
  }
};
</script>

<style lang="scss" scoped>
h2,
h4 {
  text-align: center !important;
}
i.fa-2x {
  margin-right: 10px;
}
</style>

